import React from 'react';
export interface Pack {
  id: string;
  name: string;
  capsules: string;
  subtitle: string;
  price: string;
  originalPrice?: string;
  tag?: string;
  tagColor?: 'violet' | 'amber';
}
const packs: Pack[] = [{
  id: 'pack-2x1',
  name: 'Pack 2x1',
  capsules: '60 Gomitas',
  subtitle: 'Para 2 meses + ENVÍO GRATIS',
  price: '$49.390'
}, {
  id: 'pack-4m',
  name: 'Pack 4 Meses',
  capsules: '120 Gomitas',
  subtitle: 'Para 4 meses + ENVÍO GRATIS',
  price: '$59.290',
  originalPrice: '$98.780',
  tag: 'MÁS ELEGIDO',
  tagColor: 'amber'
}, {
  id: 'pack-6m',
  name: 'Pack 6 Meses',
  capsules: '180 Gomitas',
  subtitle: 'Para 6 meses + ENVÍO GRATIS',
  price: '$69.290',
  originalPrice: '$148.170',
  tag: 'MEJOR OPCIÓN',
  tagColor: 'violet'
}, {
  id: 'pack-anual',
  name: 'Pack Anual',
  capsules: '360 Gomitas',
  subtitle: 'Para 12 meses + ENVÍO GRATIS',
  price: '$105.290',
  originalPrice: '$296.340',
  tag: 'DESCUENTO EXCLUSIVO',
  tagColor: 'violet'
}];
interface PackSelectorProps {
  selectedPackId: string;
  onSelectPack: (id: string) => void;
}
export function PackSelector({
  selectedPackId,
  onSelectPack
}: PackSelectorProps) {
  return <div className="flex flex-col gap-3" data-id="element-195">
      {packs.map(pack => {
      const isSelected = selectedPackId === pack.id;
      return <label key={pack.id} className={`relative flex items-center justify-between p-4 rounded-xl border-2 cursor-pointer transition-all ${isSelected ? 'border-esbelta-violet bg-esbelta-lavender/30' : 'border-gray-200 hover:border-esbelta-violet/50 bg-white'}`} data-id="element-196">
            {pack.tag && <div className={`absolute -top-3 right-4 px-3 py-0.5 rounded-full text-[10px] font-bold text-white uppercase tracking-wider ${pack.tagColor === 'amber' ? 'bg-esbelta-amber' : 'bg-esbelta-violet'}`} data-id="element-197">
                {pack.tag}
              </div>}

            <div className="flex items-center gap-3" data-id="element-198">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-esbelta-violet' : 'border-gray-300'}`} data-id="element-199">
                {isSelected && <div className="w-2.5 h-2.5 bg-esbelta-violet rounded-full" data-id="element-200" />}
              </div>
              <div data-id="element-201">
                <div className="flex items-center gap-2" data-id="element-202">
                  <span className="font-bold text-gray-900" data-id="element-203">{pack.name}</span>
                  <span className="px-2 py-0.5 rounded-full bg-esbelta-lavender text-esbelta-violet text-[11px] font-bold" data-id="element-204">
                    {pack.capsules}
                  </span>
                </div>
                <div className="text-xs text-gray-500 font-medium" data-id="element-205">
                  {pack.subtitle}
                </div>
              </div>
            </div>

            <div className="text-right" data-id="element-206">
              <div className="font-bold text-lg text-esbelta-violet" data-id="element-207">
                {pack.price}
              </div>
              {pack.originalPrice && <div className="text-xs text-gray-400 line-through" data-id="element-208">
                  {pack.originalPrice}
                </div>}
            </div>
          </label>;
    })}
    </div>;
}